import { Tooltip } from "antd";

import { getCompanyId } from "@lhd/utility";

import { useEffect, useRef } from "react";

const LogoCompany = ({ company }: any) => {
  const companyId = getCompanyId();
  const active = companyId ? company.id == companyId : company.is_work_default;
  const refLogo = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (refLogo.current && active) {
      const rect = refLogo.current.getBoundingClientRect();
      const container = document.querySelector(
        ".container-side_bar_company",
      ) as HTMLDivElement;
      container.scrollTo({
        top: rect.top - 48 - container?.offsetHeight / 2,
        behavior: "smooth",
      });
    }
  }, []);
  if (company.logo) {
    return (
      <Tooltip
        title={company.name}
        placement="right"
        overlayStyle={{ position: "fixed" }}
      >
        <div
          className="container-img_logo"
          style={{
            border: `2px solid ${active ? "#1E90FF" : "transparent"}`,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: 14,
            cursor: "pointer",
          }}
          ref={active ? refLogo : null}
        >
          <img
            style={{
              width: "40px",
              height: "40px",
              borderRadius: 10,
              margin: "2px",
              objectFit: "cover",
            }}
            src={company.logo}
            alt={company.name}
          />
        </div>
      </Tooltip>
    );
  } else {
    const textSubCompany = company.name?.slice(0, 2) || "";
    return (
      <Tooltip
        title={company.name}
        placement="right"
        overlayStyle={{ position: "fixed" }}
      >
        <div
          className="container-img_logo"
          style={{
            border: `2px solid ${active ? "#1E90FF" : "transparent"}`,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: 13,
            cursor: "pointer",
          }}
          ref={active ? refLogo : null}
        >
          <img
            style={{
              display: "none",
            }}
            src={company.logo}
            alt={company.name}
          />
          <div
            style={{
              width: "40px",
              height: "40px",
              borderRadius: 10,
              margin: "2px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              background: "#60687b",
              color: "#dddfe6",
              fontSize: 30,
            }}
          >
            <span
              style={{
                marginBottom: 12,
                height: "40px",
                overflow: "hidden",
                textAlign: "center",
              }}
              aria-label={company.name}
              role="img"
            >
              {textSubCompany}
            </span>
          </div>
        </div>
      </Tooltip>
    );
  }
};

export default LogoCompany;
